export const earnpoint = {
    title: 'Earn point',
    whopper_level: 'Whopper {0} Level',
    have_crowns: 'You have {0} crowns',
    show_our_staff: 'Show our staff this QR code to receive points',
    qr_code_valid: 'QR code valid for',
    min: 's',
    your_point_update: 'Your point will be updated the next day 02.00 pm.',
    point_history: 'Point history',
    benefits: 'Benefits'
};
